const semanticClassNames = {
    root: 'box',
};
export default semanticClassNames;
//# sourceMappingURL=Container.semanticClassNames.js.map